export function formatNaira(amount) {
  const n = Number(amount || 0);
  return new Intl.NumberFormat("en-NG", {
    style: "currency",
    currency: "NGN",
    maximumFractionDigits: 2,
  }).format(n);
}

export function round2(n) {
  return Math.round(Number(n || 0) * 100) / 100;
}

export function monthLabel(dateStr) {
  // YYYY-MM-01 -> Jan 2026
  const d = new Date(`${dateStr}T00:00:00`);
  return d.toLocaleString("en-US", { month: "short", year: "numeric" });
}
